module.exports = __webpack_public_path__ + "img/iso1328-1-2013_figG01_adjacent-pitch-difference.9796d1bf.png";